import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { SeguimentTecnicService } from '../services/seguiment-tecnic-service/seguiment-tecnic.service';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface IRequestOfRows {
  limit: number;
  skip: number;
  filters: any;
  conds: any;
  ordering: any;
}

@Component({
  template: ''
})
class BaseSeguimentTecnicComponent implements OnInit {
  public elementList: {'offset':0, 'registers':0, 'rows': Array<any>};
  private unsubscriber : Subject<void> = new Subject<void>();

  public sendRows(req: IRequestOfRows) {
    this.requestService.getActive(req.limit, req.skip, req.filters, req.conds, req.ordering)
      .subscribe(
        elements => { console.log(elements);this.elementList = elements; },
        error => console.log(error)
      );
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, private requestService: SeguimentTecnicService) {}

  ngOnInit(){
    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

}

@Component({
  selector: 'mcrit-gestio-seguiment-tecnic',
  template: `
    <mcrit-gestio-seguiment-tecnic-list
      (requestRows)="sendRows($event)"
      [elementList]="elementList">
    </mcrit-gestio-seguiment-tecnic-list>`,
  styleUrls: ['seguiment-tecnic.component.css'],
  providers: [  ]
})

export class SeguimentTecnicComponent extends BaseSeguimentTecnicComponent {
  
  constructor(public translate: TranslateService, public languageService: LanguageService, spService: SeguimentTecnicService) {
    super(translate, languageService, spService);
  }

}
